import React from 'react'
import { useSelector } from 'react-redux'

export const CssHexCell = ({ cssHex, displayType = null, height = null, width = null, border = null }) => {
  if (!cssHex || displayType !== 'Swatch') {
    return null
  }

  const style = {
    backgroundColor: cssHex,
    width: width || '20px',
    height: height || '20px',
    border: border || '1px solid #000'
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100">
      <div style={style}></div>
    </div>
  )
}

export const ImageCell = ({ iconData, maxWidth = null }) => {
  if (!iconData || !iconData.url) {
    return null
  }
  const style = {
    maxWidth: maxWidth || '50px'
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100">
      <img src={iconData.url} style={style} alt="icon" />
    </div>
  )
}

export const getCurrentAgencyId = () => {
  let currentAgencyId = useSelector(state => state.current.agency)
  if (currentAgencyId) {
    currentAgencyId = currentAgencyId.id
  } else {
    // if there is no current agency, then we are an organization
    currentAgencyId = useSelector(state => state.current.organization.name)
  }
  return currentAgencyId
}

export const insertAtPosition = (str, char, position) => {
  return str.slice(0, position) + char + str.slice(position)
}
